module.exports = __webpack_public_path__ + "img/view-star.8573923a.png";